import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=35672ace&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35672ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35672ace')) {
      api.createRecord('35672ace', component.options)
    } else {
      api.reload('35672ace', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=35672ace&scoped=true&", function () {
      api.rerender('35672ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/reports/severity/Index.vue"
export default component.exports